
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ButtonParams, ExtendedMap } from '@jeppesen-foreflight/jmkw-types';
import { ButtonHostComponent } from './button-host/button-host.component';

@Component({
  selector: 'jmkw-toolbar',
  standalone: true,
  imports: [ButtonHostComponent],
  template: `<jmkw-button-host
    [buttonMap]="buttonMap"
    data-testid="jmkw-toolbar"
  ></jmkw-button-host>`,
  styleUrls: ['./toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToolbarComponent {
  @Input() buttonMap!: ExtendedMap<ButtonParams>;
}
